//activate show / hide additional info
$('.hover-to-show-link').on('click', function(){
    const circlePlus = $(this).find('.circle-plus');
    $(circlePlus).toggleClass('opened');
});
